"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAPIData = withAPIData;
exports.WithAPIData = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _index = _interopRequireDefault(require("axios/index"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WithAPIDataBase = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(WithAPIDataBase, _Component);

  var _super = _createSuper(WithAPIDataBase);

  function WithAPIDataBase(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, WithAPIDataBase);
    _this = _super.call(this, props);
    _this.state = {
      data: null,
      loading: true
    };
    _this.timout = null;
    _this.source = null;
    _this.dummyData = _this.props.dummyData;
    _this.checkDummyData = _this.checkDummyData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getData = _this.getData.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(WithAPIDataBase, [{
    key: "checkDummyData",
    value: function checkDummyData() {
      var component = this;

      if (this.dummyData != null) {
        // fake a loading time
        this.timout = setTimeout(function () {
          component.setState({
            loading: false,
            data: component.dummyData
          });
        }, 750);
      } else {
        // i think the getData is what breaks the react lifecycle
        this.timout = setTimeout(function () {
          component.getData();
        }, 750);
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      var component = this;
      var CancelToken = _index["default"].CancelToken;
      this.source = CancelToken.source();

      var compiled = _.template(this.props.url);

      var url = compiled(this.props.componentProps || {});
      var requestConfig = {
        cancelToken: this.source.token,
        url: url
      };
      this.props.axiosInstance(requestConfig).then(function (response) {
        component.setState({
          loading: false,
          data: response.data
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkDummyData();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.source != null) {
        this.source.cancel();
      } else if (this.timeout != null) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        data: this.state.data,
        loading: this.state.loading
      });
    }
  }]);
  return WithAPIDataBase;
}(_react.Component);

WithAPIDataBase.defaultProps = {
  dummyData: null,
  axiosInstance: _index["default"]
};
var WithAPIData = WithAPIDataBase;
exports.WithAPIData = WithAPIData;

function withAPIData(WrappedComponent, url) {
  var dummyData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var axiosInstance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _index["default"];
  return /*#__PURE__*/function (_Component2) {
    (0, _inherits2["default"])(_class, _Component2);

    var _super2 = _createSuper(_class);

    function _class() {
      (0, _classCallCheck2["default"])(this, _class);
      return _super2.apply(this, arguments);
    }

    (0, _createClass2["default"])(_class, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        return /*#__PURE__*/_react["default"].createElement(WithAPIData, {
          url: url,
          dummyData: dummyData,
          componentProps: this.props,
          axiosInstance: axiosInstance
        }, function (_ref) {
          var data = _ref.data,
              loading = _ref.loading;
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
            data: data,
            loading: loading
          }, _this2.props));
        });
      }
    }]);
    return _class;
  }(_react.Component);
}